import s from '../../styles/components/redeem/RedeemOffer.module.css';

export default function RedeemOffer({ ui, data, onContinue }) {
  const { customer, reward } = data;

  return (
    <div className={s.wrap}>
      <span className={s.eyebrow}>{ui.eyebrow}</span>
      <h2 className={s.headline}>{reward.label}</h2>
      <p className={s.description}>{reward.description}</p>
      <div className={s.divider} />
      <div className={s.meta}>
        <div className={s.metaRow}>
          <span className={s.metaLabel}>For</span>
          <span className={s.metaValue}>{customer.name}</span>
        </div>
        <div className={s.metaRow}>
          <span className={s.metaLabel}>Expires</span>
          <span className={s.metaValue}>{reward.expiry}</span>
        </div>
      </div>
      <div className={s.terms}>{reward.terms}</div>
      <div className={s.divider} />
      <p className={s.instruction}>{ui.instruction}</p>
      <button onClick={onContinue} className={s.btn}>Redeem Now</button>
    </div>
  );
}